import { Fragment, useEffect, useRef, useState } from "react";
import { ArrowRight, ArrowDown } from "lucide-react";

function Reveal({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setShown(true); io.disconnect(); }
    }, { threshold: 0.2, rootMargin: "0px 0px -40px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div ref={ref} className={className}
      style={{
        transition: "opacity 0.7s ease, transform 0.7s ease",
        transitionDelay: `${delay}ms`,
        opacity: shown ? 1 : 0,
        transform: shown ? "none" : "translateY(24px)",
      }}>
      {children}
    </div>
  );
}

export const JourneyDiagram = ({ steps, testidPrefix }) => (
  <div className="mt-14 flex flex-col items-stretch gap-4 lg:flex-row lg:gap-2">
    {steps.map((s, i) => {
      const Icon = s.icon;
      const last = i === steps.length - 1;
      return (
        <Fragment key={s.title}>
          <Reveal delay={i * 130} className="flex-1">
            <div data-testid={`${testidPrefix}-step-${i + 1}`}
              className={`relative h-full rounded-2xl border bg-white p-6 pt-9 transition-all hover:-translate-y-1 hover:shadow-xl ${
                last ? "border-[#ECC764]/60 bg-gradient-to-b from-[#ECC764]/10 to-white hover:border-[#ECC764]"
                     : "border-neutral-200 hover:border-[#0A8B85]/40"}`}>
              <span className={`absolute -top-4 left-6 flex h-8 w-8 items-center justify-center rounded-full text-xs font-extrabold text-white ring-4 ring-white ${
                last ? "bg-[#D1A330]" : "bg-[#04302E]"}`}>
                {i + 1}
              </span>
              <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${
                last ? "bg-[#ECC764]/25 text-[#8a6a1c]" : "bg-[#0A8B85]/10 text-[#0A8B85]"}`}>
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="mt-3 text-base font-bold text-neutral-900">{s.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-neutral-600">{s.body}</p>
            </div>
          </Reveal>
          {!last && (
            <div className="flex shrink-0 items-center justify-center" aria-hidden="true">
              <span className="flex h-8 w-8 items-center justify-center rounded-full border border-[#0A8B85]/25 bg-[#0A8B85]/10 text-[#0A8B85]">
                <ArrowRight className="hidden h-4 w-4 lg:block" />
                <ArrowDown className="h-4 w-4 lg:hidden" />
              </span>
            </div>
          )}
        </Fragment>
      );
    })}
  </div>
);
